// import React from 'react';
// import styled from 'styled-components';

// const PageContainer = styled.div`
//     padding: 100px 20px;
//     max-width: 1200px;
//     margin: 0 auto;
// `;

// const HeroSection = styled.section`
//     text-align: center;
//     margin-bottom: 60px;
// `;

// const Title = styled.h1`
//     font-size: 3rem;
//     color: #1a2a6c;
//     margin-bottom: 20px;
//     text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
// `;

// const Subtitle = styled.p`
//     font-size: 1.2rem;
//     color: #2c3e50;
//     max-width: 800px;
//     margin: 0 auto;
//     line-height: 1.6;
// `;

// const ContentSection = styled.section`
//     display: grid;
//     grid-template-columns: 1fr 1fr;
//     gap: 40px;
//     margin-top: 40px;

//     @media (max-width: 768px) {
//         grid-template-columns: 1fr;
//     }
// `;

// const FeatureCard = styled.div`
//     background: #fff;
//     padding: 30px;
//     border-radius: 10px;
//     box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
//     transition: transform 0.3s ease;

//     &:hover {
//         transform: translateY(-5px);
//     }
// `;

// const FeatureTitle = styled.h2`
//     color: #1a2a6c;
//     margin-bottom: 15px;
//     font-size: 1.8rem;
// `;

// const FeatureDescription = styled.p`
//     color: #666;
//     line-height: 1.6;
//     margin-bottom: 20px;
// `;

// const TechStack = styled.div`
//     margin-top: 20px;
// `;

// const TechTitle = styled.h3`
//     color: #1a2a6c;
//     margin-bottom: 10px;
//     font-size: 1.2rem;
// `;

// const TechList = styled.div`
//     display: flex;
//     flex-wrap: wrap;
//     gap: 10px;
// `;

// const TechItem = styled.span`
//     background: #f0f2f5;
//     padding: 8px 16px;
//     border-radius: 20px;
//     color: #1a2a6c;
//     font-size: 0.9rem;
// `;

// const CloudSolutions = () => {
//     return (
//         <PageContainer>
//             <HeroSection>
//                 <Title>Cloud Solutions</Title>
//                 <Subtitle>
//                     Transform your business with scalable, secure, and efficient cloud infrastructure
//                     solutions tailored to your needs.
//                 </Subtitle>
//             </HeroSection>

//             <ContentSection>
//                 <FeatureCard>
//                     <FeatureTitle>Cloud Migration</FeatureTitle>
//                     <FeatureDescription>
//                         Seamless transition of your applications and data to the cloud with minimal
//                         disruption and maximum efficiency.
//                     </FeatureDescription>
//                     <TechStack>
//                         <TechTitle>Our Migration Services:</TechTitle>
//                         <TechList>
//                             <TechItem>Assessment</TechItem>
//                             <TechItem>Planning</TechItem>
//                             <TechItem>Execution</TechItem>
//                             <TechItem>Optimization</TechItem>
//                             <TechItem>Support</TechItem>
//                         </TechList>
//                     </TechStack>
//                 </FeatureCard>

//                 <FeatureCard>
//                     <FeatureTitle>Cloud Infrastructure</FeatureTitle>
//                     <FeatureDescription>
//                         Build and manage robust cloud infrastructure that scales with your business
//                         needs.
//                     </FeatureDescription>
//                     <TechStack>
//                         <TechTitle>Platforms We Work With:</TechTitle>
//                         <TechList>
//                             <TechItem>AWS</TechItem>
//                             <TechItem>Azure</TechItem>
//                             <TechItem>Google Cloud</TechItem>
//                             <TechItem>Private Cloud</TechItem>
//                             <TechItem>Hybrid Cloud</TechItem>
//                         </TechList>
//                     </TechStack>
//                 </FeatureCard>

//                 <FeatureCard>
//                     <FeatureTitle>Cloud Security</FeatureTitle>
//                     <FeatureDescription>
//                         Comprehensive security solutions to protect your cloud infrastructure and
//                         data.
//                     </FeatureDescription>
//                     <TechStack>
//                         <TechTitle>Security Features:</TechTitle>
//                         <TechList>
//                             <TechItem>Encryption</TechItem>
//                             <TechItem>Access Control</TechItem>
//                             <TechItem>Compliance</TechItem>
//                             <TechItem>Monitoring</TechItem>
//                             <TechItem>Backup</TechItem>
//                         </TechList>
//                     </TechStack>
//                 </FeatureCard>

//                 <FeatureCard>
//                     <FeatureTitle>Cloud Management</FeatureTitle>
//                     <FeatureDescription>
//                         Proactive monitoring, optimization, and management of your cloud resources
//                         for optimal performance and cost-efficiency.
//                     </FeatureDescription>
//                     <TechStack>
//                         <TechTitle>Management Services:</TechTitle>
//                         <TechList>
//                             <TechItem>Monitoring</TechItem>
//                             <TechItem>Cost Optimization</TechItem>
//                             <TechItem>Performance Tuning</TechItem>
//                             <TechItem>Resource Management</TechItem>
//                             <TechItem>24/7 Support</TechItem>
//                         </TechList>
//                     </TechStack>
//                 </FeatureCard>
//             </ContentSection>
//         </PageContainer>
//     );
// };

// export default CloudSolutions; 


import React from 'react';
import styled, { keyframes } from 'styled-components';
import { motion } from 'framer-motion';
import { 
  FaCloud, 
  FaServer, 
  FaShieldAlt, 
  FaCogs, 
  FaSync, 
  FaDatabase, 
  FaLock, 
  FaEye,
  FaChartLine,
  FaDollarSign,
  FaRocket,
  FaAws,
  FaMicrosoft,
  FaGoogle,
  FaNetworkWired,
  FaClock
} from 'react-icons/fa';

// Animations
const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const gradientShift = keyframes`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`;

const float = keyframes`
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
`;

const pulse = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
`;

// Styled Components
const PageContainer = styled.div`
  padding: 120px 20px 80px;
  max-width: 1400px;
  margin: 0 auto;
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, #e2e8f0, transparent);
  }
`;

const HeroSection = styled(motion.section)`
  text-align: center;
  margin-bottom: 80px;
  padding: 60px 40px;
  background: linear-gradient(135deg, var(--theme-hero-start) 0%, var(--theme-hero-end) 50%, var(--theme-hero-start) 100%);
  border-radius: 24px;
  color: #FFFFFF;
  position: relative;
  overflow: hidden;
  box-shadow: 0 20px 40px var(--theme-shadow-accent);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: 
      radial-gradient(circle at 20% 80%, rgba(120, 119, 198, 0.1) 0%, transparent 50%),
      radial-gradient(circle at 80% 20%, rgba(255, 200, 87, 0.1) 0%, transparent 50%);
    background-blend-mode: overlay;
  }

  @media (max-width: 768px) {
    padding: 40px 20px;
    margin-bottom: 60px;
  }
`;

const Title = styled.h1`
  font-size: clamp(2.5rem, 5vw, 4rem);
  font-weight: 800;
  margin-bottom: 20px;
  letter-spacing: -0.02em;
  position: relative;
  z-index: 2;
  
  span {
    display: block;
    font-size: clamp(1rem, 2vw, 1.5rem);
    color: #FFC857;
    margin-top: 1rem;
    font-weight: 600;
    letter-spacing: 0.3em;
    text-transform: uppercase;
    background: linear-gradient(135deg, #FFC857, #FF9F1C);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
`;

const Subtitle = styled.p`
  font-size: clamp(1.1rem, 2vw, 1.4rem);
  color: rgba(244, 244, 244, 0.95);
  max-width: 700px;
  margin: 0 auto;
  line-height: 1.6;
  font-weight: 300;
  position: relative;
  z-index: 2;
`;

const ContentSection = styled(motion.section)`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 40px;
  margin-top: 40px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 30px;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 25px;
  }
`;

const FeatureCard = styled(motion.div)`
  background: #ffffff;
  padding: 50px 40px;
  border-radius: 20px;
  box-shadow: 
    0 10px 30px rgba(0, 0, 0, 0.08),
    0 0 0 1px rgba(0, 0, 0, 0.03);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  border-top: 4px solid var(--theme-accent);
  cursor: pointer;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, var(--theme-accent-soft), transparent);
    transition: left 0.6s ease;
  }

  &:hover {
    transform: translateY(-8px);
    box-shadow: 
      0 25px 50px -12px rgba(0, 0, 0, 0.15),
      0 0 0 1px rgba(0, 0, 0, 0.03);

    &::before {
      left: 100%;
    }

    .feature-icon {
      transform: scale(1.1);
      color: var(--theme-accent);
      animation: ${float} 3s ease-in-out infinite;
    }
  }

  @media (max-width: 768px) {
    padding: 40px 30px;
  }

  @media (max-width: 480px) {
    padding: 35px 25px;
  }
`;

const FeatureHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 25px;
`;

const FeatureIcon = styled.div`
  font-size: 3rem;
  color: var(--theme-primary);
  transition: all 0.4s ease;
  flex-shrink: 0;

  @media (max-width: 480px) {
    font-size: 2.5rem;
  }
`;

const FeatureTitle = styled.h2`
  color: var(--theme-primary);
  margin: 0;
  font-size: 1.8rem;
  font-weight: 700;
  line-height: 1.2;

  @media (max-width: 480px) {
    font-size: 1.6rem;
  }
`;

const FeatureDescription = styled.p`
  color: #64748b;
  line-height: 1.7;
  margin-bottom: 25px;
  font-size: 1.05rem;
  font-weight: 400;
`;

const TechStack = styled.div`
  margin-top: 25px;
`;

const TechTitle = styled.h3`
  color: var(--theme-primary);
  margin-bottom: 15px;
  font-size: 1.2rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 10px;
`;

const TechList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

const TechItem = styled(motion.span)`
  background: var(--theme-surface-muted);
  color: var(--theme-primary);
  padding: 10px 18px;
  border-radius: 12px;
  font-size: 0.9rem;
  font-weight: 500;
  border: 1px solid var(--theme-border);
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    background: var(--theme-accent-soft);
    color: var(--theme-accent);
    border-color: var(--theme-accent-soft);
    transform: translateY(-2px);
  }

  @media (max-width: 480px) {
    padding: 8px 14px;
    font-size: 0.85rem;
  }
`;

const BenefitsSection = styled(motion.section)`
  margin-top: 80px;
  padding: 60px 40px;
  background: linear-gradient(135deg, var(--theme-hero-start) 0%, var(--theme-hero-end) 100%);
  border-radius: 24px;
  color: white;
  text-align: center;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23ffffff' fill-opacity='0.03'%3E%3Cpath d='m0 40l40-40h-40v40zm40 0v-40h-40l40 40z'/%3E%3C/g%3E%3C/svg%3E");
  }

  @media (max-width: 768px) {
    padding: 40px 20px;
    margin-top: 60px;
  }
`;

const SectionTitle = styled.h2`
  font-size: clamp(2rem, 4vw, 3rem);
  color: #FFFFFF;
  margin-bottom: 50px;
  position: relative;
  z-index: 2;
  font-weight: 800;
  letter-spacing: -0.02em;
`;

const BenefitsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
  position: relative;
  z-index: 2;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 25px;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 20px;
  }
`;

const BenefitCard = styled(motion.div)`
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  padding: 30px 25px;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.15);
    transform: translateY(-5px);
  }

  @media (max-width: 480px) {
    padding: 25px 20px;
  }
`;

const BenefitIcon = styled.div`
  font-size: 2.5rem;
  color: #FFC857;
  margin-bottom: 20px;
`;

const BenefitTitle = styled.h3`
  color: #FFC857;
  margin-bottom: 15px;
  font-size: 1.3rem;
  font-weight: 600;
`;

const BenefitDescription = styled.p`
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.6;
  font-size: 1rem;
`;

const CTAButton = styled(motion.a)`
  background: linear-gradient(135deg, #FFC857, #FF9F1C);
  color: var(--theme-primary);
  padding: 1.2rem 3rem;
  border-radius: 50px;
  text-decoration: none;
  font-weight: 700;
  font-size: 1.1rem;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 
    0 8px 25px rgba(255, 200, 87, 0.3),
    inset 0 1px 0 rgba(255,255,255,0.3);
  position: relative;
  overflow: hidden;
  display: inline-flex;
  align-items: center;
  gap: 1rem;
  margin-top: 50px;
  letter-spacing: 0.5px;
  border: none;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent);
    transition: left 0.6s ease;
  }
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 
      0 12px 30px rgba(255, 200, 87, 0.4),
      inset 0 1px 0 rgba(255,255,255,0.3);
    
    &::before {
      left: 100%;
    }
  }

  @media (max-width: 480px) {
    padding: 1rem 2.5rem;
    font-size: 1rem;
    margin-top: 40px;
  }
`;

const CloudProvidersSection = styled(motion.section)`
  margin-top: 80px;
  padding: 60px 40px;
  background: #ffffff;
  border-radius: 24px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
  text-align: center;

  @media (max-width: 768px) {
    padding: 40px 20px;
    margin-top: 60px;
  }
`;

const ProvidersGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 40px;
  margin-top: 40px;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 25px;
  }
`;

const ProviderCard = styled(motion.div)`
  background: #f8fafc;
  padding: 40px 30px;
  border-radius: 16px;
  border: 2px solid transparent;
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    background: #ffffff;
    border-color: var(--theme-accent);
    transform: translateY(-5px);
    box-shadow: 0 10px 25px var(--theme-shadow-accent);
  }

  @media (max-width: 480px) {
    padding: 30px 20px;
  }
`;

const ProviderIcon = styled.div`
  font-size: 3rem;
  color: var(--theme-primary);
  margin-bottom: 20px;
`;

const ProviderName = styled.h3`
  color: var(--theme-primary);
  font-size: 1.3rem;
  font-weight: 600;
  margin-bottom: 10px;
`;

const ProviderDescription = styled.p`
  color: #64748b;
  font-size: 0.95rem;
  line-height: 1.5;
`;

const CloudSolutions = () => {
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2
            }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.6,
                ease: "easeOut"
            }
        }
    };

    return (
        <PageContainer>
            <HeroSection
                variants={containerVariants}
                initial="hidden"
                animate="visible"
            >
                <Title variants={itemVariants}>
                    Cloud Solutions
                    <span>Scalable & Secure Infrastructure</span>
                </Title>
                <Subtitle variants={itemVariants}>
                    Transform your business with scalable, secure, and efficient cloud infrastructure
                    solutions tailored to your needs. Leverage the power of cloud computing to drive innovation and growth.
                </Subtitle>
            </HeroSection>

            <ContentSection
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
            >
                <FeatureCard
                    variants={itemVariants}
                    whileHover={{ y: -5 }}
                >
                    <FeatureHeader>
                        <FeatureIcon className="feature-icon">
                            <FaSync />
                        </FeatureIcon>
                        <FeatureTitle>Cloud Migration</FeatureTitle>
                    </FeatureHeader>
                    <FeatureDescription>
                        Seamless transition of your applications and data to the cloud with minimal
                        disruption and maximum efficiency. Our proven migration strategy ensures
                        business continuity and optimal performance.
                    </FeatureDescription>
                    <TechStack>
                        <TechTitle>
                            <FaSync />
                            Our Migration Services
                        </TechTitle>
                        <TechList>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                <FaChartLine /> Assessment
                            </TechItem>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                Planning
                            </TechItem>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                <FaRocket /> Execution
                            </TechItem>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                Optimization
                            </TechItem>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                <FaClock /> Support
                            </TechItem>
                        </TechList>
                    </TechStack>
                </FeatureCard>

                <FeatureCard
                    variants={itemVariants}
                    whileHover={{ y: -5 }}
                >
                    <FeatureHeader>
                        <FeatureIcon className="feature-icon">
                            <FaServer />
                        </FeatureIcon>
                        <FeatureTitle>Cloud Infrastructure</FeatureTitle>
                    </FeatureHeader>
                    <FeatureDescription>
                        Build and manage robust cloud infrastructure that scales with your business
                        needs. We design high-availability architectures that ensure reliability
                        and performance.
                    </FeatureDescription>
                    <TechStack>
                        <TechTitle>
                            <FaServer />
                            Platforms We Work With
                        </TechTitle>
                        <TechList>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                <FaAws /> AWS
                            </TechItem>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                <FaMicrosoft /> Azure
                            </TechItem>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                <FaGoogle /> Google Cloud
                            </TechItem>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                <FaNetworkWired /> Private Cloud
                            </TechItem>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                Hybrid Cloud
                            </TechItem>
                        </TechList>
                    </TechStack>
                </FeatureCard>

                <FeatureCard
                    variants={itemVariants}
                    whileHover={{ y: -5 }}
                >
                    <FeatureHeader>
                        <FeatureIcon className="feature-icon">
                            <FaShieldAlt />
                        </FeatureIcon>
                        <FeatureTitle>Cloud Security</FeatureTitle>
                    </FeatureHeader>
                    <FeatureDescription>
                        Comprehensive security solutions to protect your cloud infrastructure and
                        data. We implement multi-layered security measures to safeguard your
                        digital assets.
                    </FeatureDescription>
                    <TechStack>
                        <TechTitle>
                            <FaShieldAlt />
                            Security Features
                        </TechTitle>
                        <TechList>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                <FaLock /> Encryption
                            </TechItem>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                Access Control
                            </TechItem>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                Compliance
                            </TechItem>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                <FaEye /> Monitoring
                            </TechItem>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                <FaDatabase /> Backup
                            </TechItem>
                        </TechList>
                    </TechStack>
                </FeatureCard>

                <FeatureCard
                    variants={itemVariants}
                    whileHover={{ y: -5 }}
                >
                    <FeatureHeader>
                        <FeatureIcon className="feature-icon">
                            <FaCogs />
                        </FeatureIcon>
                        <FeatureTitle>Cloud Management</FeatureTitle>
                    </FeatureHeader>
                    <FeatureDescription>
                        Proactive monitoring, optimization, and management of your cloud resources
                        for optimal performance and cost-efficiency. We ensure your cloud
                        infrastructure runs smoothly 24/7.
                    </FeatureDescription>
                    <TechStack>
                        <TechTitle>
                            <FaCogs />
                            Management Services
                        </TechTitle>
                        <TechList>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                <FaEye /> Monitoring
                            </TechItem>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                <FaDollarSign /> Cost Optimization
                            </TechItem>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                Performance Tuning
                            </TechItem>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                Resource Management
                            </TechItem>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                <FaClock /> 24/7 Support
                            </TechItem>
                        </TechList>
                    </TechStack>
                </FeatureCard>
            </ContentSection>

            <CloudProvidersSection
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
            >
                <SectionTitle style={{ color: 'var(--theme-primary)' }} variants={itemVariants}>
                    Trusted Cloud Providers
                </SectionTitle>
                <ProvidersGrid>
                    <ProviderCard variants={itemVariants} whileHover={{ y: -5 }}>
                        <ProviderIcon>
                            <FaAws />
                        </ProviderIcon>
                        <ProviderName>AWS</ProviderName>
                        <ProviderDescription>
                            Amazon Web Services - The world's most comprehensive cloud platform
                        </ProviderDescription>
                    </ProviderCard>
                    <ProviderCard variants={itemVariants} whileHover={{ y: -5 }}>
                        <ProviderIcon>
                            <FaMicrosoft />
                        </ProviderIcon>
                        <ProviderName>Microsoft Azure</ProviderName>
                        <ProviderDescription>
                            Enterprise-grade cloud computing services and solutions
                        </ProviderDescription>
                    </ProviderCard>
                    <ProviderCard variants={itemVariants} whileHover={{ y: -5 }}>
                        <ProviderIcon>
                            <FaGoogle />
                        </ProviderIcon>
                        <ProviderName>Google Cloud</ProviderName>
                        <ProviderDescription>
                            Scalable infrastructure and data analytics cloud services
                        </ProviderDescription>
                    </ProviderCard>
                    <ProviderCard variants={itemVariants} whileHover={{ y: -5 }}>
                        <ProviderIcon>
                            <FaNetworkWired />
                        </ProviderIcon>
                        <ProviderName>Hybrid Solutions</ProviderName>
                        <ProviderDescription>
                            Custom hybrid cloud architectures for unique business needs
                        </ProviderDescription>
                    </ProviderCard>
                </ProvidersGrid>
            </CloudProvidersSection>

            <BenefitsSection
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
            >
                <SectionTitle variants={itemVariants}>
                    Cloud Benefits
                </SectionTitle>
                <BenefitsGrid>
                    <BenefitCard variants={itemVariants}>
                        <BenefitIcon>
                            <FaDollarSign />
                        </BenefitIcon>
                        <BenefitTitle>Cost Efficiency</BenefitTitle>
                        <BenefitDescription>
                            Reduce IT costs with pay-as-you-go pricing and eliminate capital expenses
                        </BenefitDescription>
                    </BenefitCard>
                    <BenefitCard variants={itemVariants}>
                        <BenefitIcon>
                            <FaRocket />
                        </BenefitIcon>
                        <BenefitTitle>Scalability</BenefitTitle>
                        <BenefitDescription>
                            Instantly scale resources up or down based on your business demands
                        </BenefitDescription>
                    </BenefitCard>
                    <BenefitCard variants={itemVariants}>
                        <BenefitIcon>
                            <FaShieldAlt />
                        </BenefitIcon>
                        <BenefitTitle>Enhanced Security</BenefitTitle>
                        <BenefitDescription>
                            Enterprise-grade security with advanced threat protection and compliance
                        </BenefitDescription>
                    </BenefitCard>
                    <BenefitCard variants={itemVariants}>
                        <BenefitIcon>
                            <FaChartLine />
                        </BenefitIcon>
                        <BenefitTitle>Business Continuity</BenefitTitle>
                        <BenefitDescription>
                            Ensure high availability and disaster recovery with automated backups
                        </BenefitDescription>
                    </BenefitCard>
                </BenefitsGrid>
                
                <CTAButton 
                    href="/contact"
                    variants={itemVariants}
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                >
                    Start Your Cloud Journey
                    <FaCloud />
                </CTAButton>
            </BenefitsSection>
        </PageContainer>
    );
};

export default CloudSolutions;
